var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloudBasedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud-based_inline_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.996 22.239c0-1.141-.399-2.236-1.111-3.052-.713-.815-1.682-1.286-2.7-1.31a.431.431 0 01-.287-.122.53.53 0 01-.154-.296c-.261-1.544-.939-2.962-1.942-4.062-1.003-1.1-2.282-1.83-3.667-2.09a6.207 6.207 0 00-4.075.635c-1.269.673-2.322 1.766-3.02 3.131a.492.492 0 01-.154.18.425.425 0 01-.212.076c-1.27.102-2.458.74-3.325 1.783C9.48 18.156 8.999 19.53 9 20.956c0 4.927 4.478 5.634 4.583 5.645h13.301c1.134-.01 2.227-.477 3.078-1.317.349-.401.62-.879.798-1.403a4.554 4.554 0 00.236-1.642zM21.5 18.5a1.5 1.5 0 01-.75 1.3v2.218a.75.75 0 01-1.5 0v-2.219A1.5 1.5 0 1121.5 18.5z",
    fill: "#0F0449"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud-based_inline_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9 9)",
    d: "M0 0h22v22H0z"
  })))));
}

export default SvgCloudBasedinline;